 import React ,{ useState,useEffect}from 'react'
import App from './App';
 import axios from './axios';
 import './row.css';
 import './App.css';
import YouTube from 'react-youtube';
import movieTrailer from 'movie-trailer'

 //const base_url="https://image.tmdb.org/t/p/orginal";
 const base_url = 'https://image.tmdb.org/t/p/original/';






 function Row({title,fetchUrl,isLargeRow}) { 
        const [movies,setMovies]= useState([]);
        //snippet of code which runs on specifc condition/variable
const [trailerUrl,setTrailerUrl]=useState("")
     useEffect(() => {
         
         //return () => {
            // run once when the roew loads and dont run it again
            async function fetchData(){
                const request=await axios.get(fetchUrl);
                setMovies(request.data.results);
                //console.log(request.data.results)
              //  console.table(movies)
                
                return request;
            }
          fetchData();
         //}
     }, [fetchUrl]);
     const opts={
         hieght:"390",
         width:"100%",
         playerVars: {
            // https://developers.google.com/youtube/player_parameters
            autoplay: 1,}
     }
     const handleClick = (movie )=>{
         if(trailerUrl){
             setTrailerUrl("")

         }else {
             movieTrailer(movie?.name ||"")
             .then(url=>{
                 //const Urlpatams=new URLSEarchparams(new URL(url).search;)
                 const Urlparams=new URLSearchParams(new URL(url).search);
                 setTrailerUrl(Urlparams.get("v"));


             }).catch(error=>console.error())
         }

     }


     return (
         <div className="row">
              {/*title */}
             <h1>{title}</h1>
             <div className="row_posters" >
                 {movies.map(movie => (
                     <img  key={movie.id} 
                     onClick={()=>handleClick(movie)}
                     className={`row_poster ${isLargeRow && "row_posterLarge"}` } 
                    src={`${base_url}${isLargeRow ? movie.poster_path : movie.backdrop_path}`} 
                //    src={`${base_url}${movie.poster_path}`}
                     alt={movie.title}></img>
                 ))}
             </div>
           {trailerUrl &&  <YouTube videoId={trailerUrl}></YouTube>}
          </div>       
             
     )
 }
 
 export default Row
 